<template >
    <div class="container">
        <div class="container-card">
            <v-container>
                <v-row>
                    <v-col cols="12" md="3">
                        <card-dashboard class="rounded-lg" text="Hotéis Ativos" button="ver hotéis" type="hotel" contador="total"
                                        :count="count.totalOfHotels" icon="mdi-home-modern"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <card-dashboard class="rounded-lg" text="Hotéis Cadastrados no Mês" button="ver hotéis" type="thisMonthHotel"
                                        :count="count.montlyHotels" icon="mdi-calendar"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <card-dashboard class="rounded-lg" text="Reservas Pendentes de Confirmação" button="ver reservas" type="status"
                                        :count="count.pendingBookings" icon="mdi-alert"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <card-dashboard class="rounded-lg" text="Reservas Feitas no Mês" button="ver reservas" type="thisMonth"
                                        :count="count.montlyBookings" icon="mdi-calendar"/>
                    </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                    <v-col cols="12" md="3">
                        <card-dashboard class="rounded-lg" text="Reservas Pendentes de Nota Fiscal" button="ver reservas"
                                        type="pendingInvoice" :count="count.bookingsPendingInvoices" icon="mdi-file-clock-outline"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <card-dashboard class="rounded-lg" text="Reservas Não Respondidas" button="ver reservas"
                                        type="unanswered" :count="count.bookingsUnanswered" icon="mdi-message-off"/>
                    </v-col>
                    <v-col cols="12" md="3">
                        <card-dashboard class="rounded-lg" text="Reservas Com Pagamento Não Efetuado" button="ver reservas"
                                        type="unpaid" :count="count.bookingsUnpaid" icon="mdi-cash-remove"/>
                    </v-col>
                </v-row>
            </v-container>
            <v-container
                class="mt-5 container-chart" >
                <chart-card/>
            </v-container>
        </div>
    </div>


</template>

<script>
import ChartCard from "../components/ChartCard";
import CardDashboard from "../components/CardDashboard";
import Button from "../Reserve/button";

export default {
    name: "Home",
    components: {
        Button,
        CardDashboard,
        ChartCard
    },
    data() {
        return {
            count: null,
        }
    },
    methods: {
        logout() {
            axios.post('/logout')
                .then(res => {
                    window.location.href = '/login'
                });

        }

    },
    mounted() {
        axios.get(`/api/dashboard`)
            .then(res => {
                this.count = res.data

            })

    },
}
</script>

<style lang="scss" scoped>
.container {
    background-color: #f0f0f0;
    height: 100%;
    width: 100%;
    max-width: 100%;
}.container-chart{
     width: 96%;
     height: 610px;
     background-color: #FFFFFF;
 }


</style>
